(function () {
  var SECTION_IDS = ['side-cart-drawer'];
  var activeUpsellProduct = null;
  var activeUpsellSelections = null;

  function getRoot() {
    return document.querySelector('[data-side-cart-root]');
  }

  function getDrawer() {
    var root = getRoot();
    return root ? root.querySelector('.side-cart__drawer') : null;
  }

  function getVariantModal() {
    var root = getRoot();
    return root ? root.querySelector('[data-side-cart-variant-modal]') : null;
  }

  function getVariantContent() {
    var modal = getVariantModal();
    return modal ? modal.querySelector('[data-side-cart-variant-content]') : null;
  }

  function getUpsellCarousel() {
    var root = getRoot();
    return root ? root.querySelector('[data-side-cart-upsells-carousel]') : null;
  }

  function getSectionsParam() {
    return SECTION_IDS.join(',');
  }

  function getSectionsUrl() {
    return window.location.pathname + window.location.search;
  }

  function parseJson(response) {
    return response.json().then(function (data) {
      if (!response.ok) {
        throw data;
      }
      return data;
    });
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (window.theme && theme.Shopify && theme.Shopify.formatMoney) {
      return theme.Shopify.formatMoney(cents, theme.money_format_with_code_preference || theme.money_format);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getGiftConfig() {
    var root = getRoot();
    var productId;
    var variantId;
    var thresholdCents;

    if (!root) {
      return null;
    }

    productId = parseInt(root.getAttribute('data-side-cart-gift-product-id'), 10);
    variantId = parseInt(root.getAttribute('data-side-cart-gift-variant-id'), 10);
    thresholdCents = parseInt(root.getAttribute('data-side-cart-gift-threshold'), 10);

    if (!productId || !variantId || !thresholdCents) {
      return null;
    }

    return {
      productId: productId,
      variantId: variantId,
      thresholdCents: thresholdCents
    };
  }

  function getLineTotal(item) {
    if (!item) {
      return 0;
    }

    if (typeof item.final_line_price === 'number') {
      return item.final_line_price;
    }

    if (typeof item.line_price === 'number') {
      return item.line_price;
    }

    if (typeof item.final_price === 'number' && typeof item.quantity === 'number') {
      return item.final_price * item.quantity;
    }

    if (typeof item.price === 'number' && typeof item.quantity === 'number') {
      return item.price * item.quantity;
    }

    return 0;
  }

  function getGiftLines(cart, giftConfig) {
    if (!cart || !cart.items || !giftConfig) {
      return [];
    }

    return cart.items.filter(function (item) {
      return item.variant_id === giftConfig.variantId || item.product_id === giftConfig.productId;
    });
  }

  function getGiftQuantity(giftLines) {
    return giftLines.reduce(function (total, item) {
      return total + (item.quantity || 0);
    }, 0);
  }

  function getQualifyingSubtotal(cart, giftConfig) {
    if (!cart || !cart.items) {
      return 0;
    }

    return cart.items.reduce(function (total, item) {
      if (giftConfig && (item.variant_id === giftConfig.variantId || item.product_id === giftConfig.productId)) {
        return total;
      }

      return total + getLineTotal(item);
    }, 0);
  }

  function fetchCartState() {
    return fetch((window.theme && theme.routes ? theme.routes.cart_url : '/cart') + '.js', {
      headers: {
        Accept: 'application/json'
      }
    }).then(parseJson);
  }

  function updateHeaderCartCount(itemCount) {
    var cartLinks = document.querySelectorAll('#site-control .cart[data-side-cart-open]');

    cartLinks.forEach(function (link) {
      var countBubble = link.querySelector('div');
      var textLink = link.querySelector('.text-link');
      var label = link.getAttribute('aria-label') || 'Cart';

      if (countBubble) {
        countBubble.textContent = itemCount;
      }

      if (textLink) {
        textLink.textContent = itemCount > 0 ? label + ' (' + itemCount + ')' : label;
      }
    });
  }

  function syncHeaderCartCount(data) {
    if (data && typeof data.item_count === 'number') {
      updateHeaderCartCount(data.item_count);
      return Promise.resolve();
    }

    return fetchCartState().then(function (cart) {
      updateHeaderCartCount(cart.item_count || 0);
    }).catch(function () {
      return Promise.resolve();
    });
  }

  function applySideCartOpenState(container) {
    var sideCartRoot;

    if (!container) {
      return;
    }

    sideCartRoot = container.querySelector('[data-side-cart-root]');

    if (!sideCartRoot) {
      return;
    }

    sideCartRoot.classList.add('is-open');
    sideCartRoot.setAttribute('aria-hidden', 'false');
  }

  function replaceSection(sectionId, html, keepOpen) {
    var current = document.getElementById('shopify-section-' + sectionId);
    if (!current || !html) {
      return;
    }

    var container = document.createElement('div');
    container.innerHTML = html.trim();

    var replacement = container.querySelector('#shopify-section-' + sectionId);
    if (replacement) {
      if (sectionId === 'side-cart-drawer' && keepOpen) {
        applySideCartOpenState(replacement);
      }
      current.replaceWith(replacement);
      return;
    }

    if (sectionId === 'side-cart-drawer' && keepOpen) {
      applySideCartOpenState(container);
    }
    current.innerHTML = html;
  }

  function applySections(sections, keepOpen) {
    if (!sections) {
      return;
    }

    SECTION_IDS.forEach(function (sectionId) {
      replaceSection(sectionId, sections[sectionId], keepOpen);
    });
  }

  function refreshSections() {
    var url = (window.theme && theme.routes && theme.routes.root_url ? theme.routes.root_url : '/') + '?sections=' + encodeURIComponent(getSectionsParam());

    return fetch(url, {
      headers: {
        Accept: 'application/json'
      }
    }).then(parseJson);
  }

  function openDrawer() {
    var root = getRoot();
    var drawer = getDrawer();

    if (!root || !drawer) {
      return;
    }

    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('side-cart-open');
    drawer.focus();
  }

  function closeDrawer() {
    var root = getRoot();

    if (!root) {
      return;
    }

    closeVariantModal();
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('side-cart-open');
  }

  function openVariantModal() {
    var modal = getVariantModal();
    if (!modal) {
      return;
    }

    modal.hidden = false;
    modal.classList.add('is-active');
  }

  function closeVariantModal() {
    var modal = getVariantModal();
    var content = getVariantContent();

    activeUpsellProduct = null;
    activeUpsellSelections = null;

    if (content) {
      content.innerHTML = '';
    }

    if (!modal) {
      return;
    }

    modal.classList.remove('is-active');
    modal.hidden = true;
  }

  function updateUpsellCarouselState() {
    var carousel = getUpsellCarousel();
    var viewport;
    var prevButton;
    var nextButton;
    var maxScrollLeft;

    if (!carousel) {
      return;
    }

    viewport = carousel.querySelector('[data-side-cart-upsells-viewport]');
    prevButton = carousel.querySelector('[data-side-cart-upsells-prev]');
    nextButton = carousel.querySelector('[data-side-cart-upsells-next]');

    if (!viewport || !prevButton || !nextButton) {
      return;
    }

    maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;

    prevButton.disabled = maxScrollLeft <= 4;
    nextButton.disabled = maxScrollLeft <= 4;
  }

  function scrollUpsellCarousel(direction) {
    var carousel = getUpsellCarousel();
    var viewport;
    var amount;
    var maxScrollLeft;
    var targetLeft;

    if (!carousel) {
      return;
    }

    viewport = carousel.querySelector('[data-side-cart-upsells-viewport]');
    if (!viewport) {
      return;
    }

    maxScrollLeft = viewport.scrollWidth - viewport.clientWidth;
    if (maxScrollLeft <= 4) {
      updateUpsellCarouselState();
      return;
    }

    amount = viewport.clientWidth + 12;
    targetLeft = viewport.scrollLeft + (direction * amount);

    if (direction > 0 && viewport.scrollLeft >= maxScrollLeft - 4) {
      targetLeft = 0;
    } else if (direction < 0 && viewport.scrollLeft <= 4) {
      targetLeft = maxScrollLeft;
    }

    viewport.scrollTo({
      left: targetLeft,
      behavior: 'smooth'
    });

    window.setTimeout(updateUpsellCarouselState, 220);
  }

  function restoreButton(button) {
    if (!button) {
      return;
    }

    button.classList.remove('is-updating');
    var originalLabel = button.getAttribute('data-side-cart-original-label');
    if (originalLabel) {
      button.innerHTML = originalLabel;
    }
    button.disabled = false;
  }

  function setButtonLoading(button, label) {
    if (!button) {
      return;
    }

    if (!button.getAttribute('data-side-cart-original-label')) {
      button.setAttribute('data-side-cart-original-label', button.innerHTML);
    }

    button.disabled = true;
    if (button.classList.contains('side-cart__variant-submit')) {
      button.classList.add('is-updating');
      return;
    }
    button.innerHTML = label;
  }

  function setButtonAdded(button) {
    if (!button) {
      return;
    }

    button.classList.remove('is-updating');
    button.innerHTML = window.theme && theme.strings ? theme.strings.productAddedToCart : 'Added to cart';
  }

  function showFormError(form, error) {
    var message = error && error.description ? error.description : 'There was a problem adding this item to the cart.';
    var container = form.querySelector('.product-status-message');

    if (container) {
      container.innerHTML = message;
      container.style.display = 'block';
    } else {
      window.alert(message);
    }
  }

  function openDrawerAnimated() {
    window.requestAnimationFrame(function () {
      openDrawer();
    });
  }

  function setPendingAddState(isPending) {
    var root = getRoot();

    if (!root) {
      return;
    }

    if (isPending) {
      root.classList.add('is-pending-add');
      if (root.querySelector('.side-cart__empty')) {
        root.classList.add('is-pending-add-empty');
      } else {
        root.classList.remove('is-pending-add-empty');
      }
      return;
    }

    root.classList.remove('is-pending-add');
    root.classList.remove('is-pending-add-empty');
  }

  function updateFromResponse(data, shouldOpen) {
    var sections = data && data.sections ? data.sections : data;
    var wasOpen = !!(getRoot() && getRoot().classList.contains('is-open'));
    var keepOpen = wasOpen;
    var shouldAnimateOpen = shouldOpen && !wasOpen;

    if (sections && sections['side-cart-drawer']) {
      applySections(sections, keepOpen);
      return syncHeaderCartCount(data).then(function () {
        updateUpsellCarouselState();
        if (shouldAnimateOpen) {
          openDrawerAnimated();
        }
      });
    }

    return refreshSections().then(function (refreshedSections) {
      applySections(refreshedSections, keepOpen);
      return syncHeaderCartCount(data);
    }).then(function () {
      updateUpsellCarouselState();
      if (shouldAnimateOpen) {
        openDrawerAnimated();
      }
    });
  }

  function updateCart(updates) {
    return fetch((window.theme && theme.routes ? theme.routes.cart_url : '/cart') + '/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates: updates,
        sections: getSectionsParam(),
        sections_url: getSectionsUrl()
      })
    }).then(parseJson);
  }

  function addFreeGiftItem(variantId) {
    var formData = new FormData();

    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', getSectionsParam());
    formData.append('sections_url', getSectionsUrl());

    return fetch((window.theme && theme.routes ? theme.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    }).then(parseJson);
  }

  function reconcileFreeGift(cart, giftConfig) {
    var giftLines;
    var qualifyingSubtotal;
    var giftQuantity;
    var updates = {};

    if (!giftConfig) {
      return Promise.resolve(null);
    }

    giftLines = getGiftLines(cart, giftConfig);
    qualifyingSubtotal = getQualifyingSubtotal(cart, giftConfig);
    giftQuantity = getGiftQuantity(giftLines);

    if (giftQuantity > 0 && qualifyingSubtotal < giftConfig.thresholdCents) {
      giftLines.forEach(function (item) {
        updates[item.key] = 0;
      });
      return updateCart(updates);
    }

    if (giftQuantity > 1) {
      giftLines.forEach(function (item, index) {
        updates[item.key] = index === 0 ? 1 : 0;
      });
      return updateCart(updates);
    }

    if (giftQuantity === 0 && qualifyingSubtotal >= giftConfig.thresholdCents) {
      return addFreeGiftItem(giftConfig.variantId);
    }

    return Promise.resolve(null);
  }

  function syncFreeGiftState(data, shouldOpen) {
    var giftConfig = getGiftConfig();

    if (!giftConfig) {
      return updateFromResponse(data, shouldOpen);
    }

    return fetchCartState().then(function (cart) {
      return reconcileFreeGift(cart, giftConfig).then(function (nextData) {
        return updateFromResponse(nextData || data, shouldOpen);
      });
    }).catch(function () {
      return updateFromResponse(data, shouldOpen);
    });
  }

  function syncFreeGiftStateInBackground() {
    var giftConfig = getGiftConfig();

    if (!giftConfig) {
      return Promise.resolve();
    }

    return fetchCartState().then(function (cart) {
      return reconcileFreeGift(cart, giftConfig);
    }).then(function (data) {
      if (data) {
        return updateFromResponse(data, false);
      }

      return Promise.resolve();
    }).catch(function () {
      return Promise.resolve();
    });
  }

  function openDrawerWithGiftSync() {
    var giftConfig = getGiftConfig();

    if (!giftConfig) {
      openDrawer();
      return;
    }

    fetchCartState().then(function (cart) {
      return reconcileFreeGift(cart, giftConfig).then(function (data) {
        if (data) {
          return updateFromResponse(data, true);
        }

        return syncHeaderCartCount(cart).then(function () {
          openDrawer();
        });
      });
    }).catch(function () {
      openDrawer();
    });
  }

  function initializeFreeGiftState() {
    var giftConfig = getGiftConfig();

    if (!giftConfig) {
      return;
    }

    fetchCartState().then(function (cart) {
      return reconcileFreeGift(cart, giftConfig);
    }).then(function (data) {
      if (data) {
        return updateFromResponse(data, false);
      }

      return Promise.resolve();
    }).catch(function () {
      return Promise.resolve();
    });
  }

  function addItem(form, button) {
    var formData = new FormData(form);
    formData.append('sections', getSectionsParam());
    formData.append('sections_url', getSectionsUrl());

    setButtonLoading(button, window.theme && theme.strings ? theme.strings.productAddingToCart : 'Adding...');
    setPendingAddState(true);
    openDrawer();

    return fetch((window.theme && theme.routes ? theme.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    }).then(parseJson).then(function (data) {
      setButtonAdded(button);
      return updateFromResponse(data, true).then(function () {
        syncFreeGiftStateInBackground();
      });
    }).then(function () {
      setPendingAddState(false);
      window.setTimeout(function () {
        restoreButton(button);
      }, 1200);
    }).catch(function (error) {
      setPendingAddState(false);
      restoreButton(button);
      showFormError(form, error);
    });
  }

  function changeLine(lineIndex, quantity, trigger) {
    trigger.classList.add('is-updating');
    if ('disabled' in trigger) {
      trigger.disabled = true;
    }

    return fetch((window.theme && theme.routes ? theme.routes.cart_url : '/cart') + '/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        line: lineIndex,
        quantity: quantity < 0 ? 0 : quantity,
        sections: getSectionsParam(),
        sections_url: getSectionsUrl()
      })
    }).then(parseJson).then(function (data) {
      return syncFreeGiftState(data, true);
    }).catch(function () {
      trigger.classList.remove('is-updating');
      if ('disabled' in trigger) {
        trigger.disabled = false;
      }
    });
  }

  function addUpsell(variantId, button, onSuccess) {
    var formData = new FormData();
    var isVariantSubmit = button && button.classList.contains('side-cart__variant-submit');
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections', getSectionsParam());
    formData.append('sections_url', getSectionsUrl());

    setButtonLoading(button, window.theme && theme.strings ? theme.strings.productAddingToCart : 'Adding...');

    return fetch((window.theme && theme.routes ? theme.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    }).then(parseJson).then(function (data) {
      if (!isVariantSubmit) {
        setButtonAdded(button);
      }
      return syncFreeGiftState(data, true).then(function () {
        if (typeof onSuccess === 'function') {
          onSuccess();
        }

        if (isVariantSubmit) {
          restoreButton(button);
        }
      });
    }).then(function () {
      if (isVariantSubmit) {
        return;
      }
      window.setTimeout(function () {
        restoreButton(button);
      }, 1200);
    }).catch(function () {
      restoreButton(button);
    });
  }

  function isDrawerForm(form) {
    if (!form || !form.className) {
      return false;
    }

    return /feedback-add_in_modal/.test(form.className);
  }

  function parseUpsellProduct(card) {
    var script = card.querySelector('[data-side-cart-upsell-product]');

    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getFirstAvailableVariant(product) {
    var availableVariant = product.variants.find(function (variant) {
      return variant.available;
    });

    return availableVariant || product.variants[0] || null;
  }

  function variantMatchesSelections(variant, selections) {
    return variant.options.every(function (optionValue, index) {
      return selections[index] === optionValue;
    });
  }

  function findMatchingVariant(product, selections) {
    return product.variants.find(function (variant) {
      return variantMatchesSelections(variant, selections);
    }) || null;
  }

  function hasAvailableVariantForSelection(product, selections) {
    return product.variants.some(function (variant) {
      return variant.available && variant.options.every(function (optionValue, index) {
        return !selections[index] || selections[index] === optionValue;
      });
    });
  }

  function normalizeSelections(product, selections) {
    var normalized = selections.slice();

    product.options.forEach(function (option, optionIndex) {
      if (hasAvailableVariantForSelection(product, normalized)) {
        return;
      }

      var fallback = option.values.find(function (value) {
        var attempt = normalized.slice();
        attempt[optionIndex] = value;
        return hasAvailableVariantForSelection(product, attempt);
      });

      if (fallback) {
        normalized[optionIndex] = fallback;
      }
    });

    return normalized;
  }

  function isOptionValueAvailable(product, optionIndex, value, selections) {
    var nextSelections = selections.slice();
    nextSelections[optionIndex] = value;

    return product.variants.some(function (variant) {
      return variant.available && variant.options.every(function (optionValue, index) {
        return !nextSelections[index] || nextSelections[index] === optionValue;
      });
    });
  }

  function renderVariantModal() {
    var content = getVariantContent();
    var selectedVariant;
    var selectedImage;
    var selectedAlt;
    var markup = '';

    if (!content || !activeUpsellProduct || !activeUpsellSelections) {
      return;
    }

    selectedVariant = findMatchingVariant(activeUpsellProduct, activeUpsellSelections);
    selectedImage = selectedVariant && selectedVariant.featuredImage ? selectedVariant.featuredImage : activeUpsellProduct.featuredImage;
    selectedAlt = selectedVariant && selectedVariant.featuredAlt ? selectedVariant.featuredAlt : (activeUpsellProduct.featuredAlt || activeUpsellProduct.title);

    markup += '<div class="side-cart__variant-product">';
    markup += '<img src="' + escapeHtml(selectedImage) + '" alt="' + escapeHtml(selectedAlt) + '" width="84" height="84">';
    markup += '<div>';
    markup += '<h3 class="side-cart__variant-title" id="side-cart-variant-title">' + escapeHtml(activeUpsellProduct.title) + '</h3>';
    if (selectedVariant) {
      markup += '<div class="side-cart__variant-price">';
      if (selectedVariant.compareAtPrice > selectedVariant.price) {
        markup += '<span class="side-cart__variant-price-compare">' + formatMoney(selectedVariant.compareAtPrice) + '</span>';
      }
      markup += '<span>' + formatMoney(selectedVariant.price) + '</span>';
      markup += '</div>';
    }
    markup += '</div>';
    markup += '</div>';

    activeUpsellProduct.options.forEach(function (option, optionIndex) {
      markup += '<div class="side-cart__variant-option">';
      markup += '<p class="side-cart__variant-option-label">' + escapeHtml(option.name) + '</p>';
      markup += '<div class="side-cart__variant-values">';

      option.values.forEach(function (value) {
        var isSelected = activeUpsellSelections[optionIndex] === value;
        var isAvailable = isOptionValueAvailable(activeUpsellProduct, optionIndex, value, activeUpsellSelections);
        markup += '<button type="button" class="side-cart__variant-value' + (isSelected ? ' is-selected' : '') + (isAvailable ? '' : ' is-unavailable') + '" data-side-cart-variant-value data-option-index="' + optionIndex + '" data-option-value="' + escapeHtml(value) + '"' + (isAvailable ? '' : ' disabled') + '>' + escapeHtml(value) + '</button>';
      });

      markup += '</div>';
      markup += '</div>';
    });

    markup += '<div class="side-cart__variant-actions">';
    markup += '<button type="button" class="button side-cart__variant-submit" data-side-cart-variant-submit';
    if (selectedVariant && selectedVariant.available) {
      markup += ' data-variant-id="' + selectedVariant.id + '"';
    } else {
      markup += ' disabled';
    }
    markup += '>';
    markup += selectedVariant && selectedVariant.available ? 'Add' : 'Sold out';
    markup += '</button>';
    markup += '</div>';

    content.innerHTML = markup;
  }

  function openUpsellVariantModal(card) {
    var product = parseUpsellProduct(card);
    var initialVariant;

    if (!product || !product.variants || !product.variants.length) {
      return;
    }

    initialVariant = getFirstAvailableVariant(product);
    if (!initialVariant) {
      return;
    }

    activeUpsellProduct = product;
    activeUpsellSelections = initialVariant.options.slice();
    renderVariantModal();
    openVariantModal();
  }

  function handleUpsellCardClick(card) {
    if (!card) {
      return;
    }

    if (card.getAttribute('data-side-cart-upsell-mode') === 'add') {
      addUpsell(card.getAttribute('data-variant-id'), card.querySelector('[data-side-cart-upsell-add]'));
      return;
    }

    openUpsellVariantModal(card);
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-side-cart-open]');
    var variantCloseTrigger;
    var closeTrigger;
    var quantityTrigger;
    var removeTrigger;
    var upsellPrevTrigger;
    var upsellNextTrigger;
    var upsellOpenTrigger;
    var variantValueTrigger;
    var variantSubmitTrigger;
    var upsellTrigger;
    var upsellCardTrigger;

    if (openTrigger) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
      openDrawerWithGiftSync();
      return;
    }

    variantCloseTrigger = event.target.closest('[data-side-cart-variant-close]');
    if (variantCloseTrigger) {
      event.preventDefault();
      closeVariantModal();
      return;
    }

    closeTrigger = event.target.closest('[data-side-cart-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    quantityTrigger = event.target.closest('[data-side-cart-quantity-change]');
    if (quantityTrigger) {
      event.preventDefault();
      changeLine(
        parseInt(quantityTrigger.getAttribute('data-line-index'), 10),
        parseInt(quantityTrigger.getAttribute('data-quantity'), 10),
        quantityTrigger
      );
      return;
    }

    removeTrigger = event.target.closest('[data-side-cart-remove]');
    if (removeTrigger) {
      event.preventDefault();
      changeLine(
        parseInt(removeTrigger.getAttribute('data-line-index'), 10),
        0,
        removeTrigger
      );
      return;
    }

    upsellPrevTrigger = event.target.closest('[data-side-cart-upsells-prev]');
    if (upsellPrevTrigger) {
      event.preventDefault();
      scrollUpsellCarousel(-1);
      return;
    }

    upsellNextTrigger = event.target.closest('[data-side-cart-upsells-next]');
    if (upsellNextTrigger) {
      event.preventDefault();
      scrollUpsellCarousel(1);
      return;
    }

    upsellCardTrigger = event.target.closest('[data-side-cart-upsell-card]');
    if (
      upsellCardTrigger &&
      !event.target.closest('[data-side-cart-upsell-add]') &&
      !event.target.closest('[data-side-cart-upsell-open]') &&
      !event.target.closest('button') &&
      !event.target.closest('script')
    ) {
      event.preventDefault();
      handleUpsellCardClick(upsellCardTrigger);
      return;
    }

    upsellOpenTrigger = event.target.closest('[data-side-cart-upsell-open]');
    if (upsellOpenTrigger) {
      event.preventDefault();
      openUpsellVariantModal(upsellOpenTrigger.closest('.side-cart__upsell-card'));
      return;
    }

    variantValueTrigger = event.target.closest('[data-side-cart-variant-value]');
    if (variantValueTrigger && activeUpsellProduct && activeUpsellSelections) {
      event.preventDefault();
      activeUpsellSelections[parseInt(variantValueTrigger.getAttribute('data-option-index'), 10)] = variantValueTrigger.getAttribute('data-option-value');
      activeUpsellSelections = normalizeSelections(activeUpsellProduct, activeUpsellSelections);
      renderVariantModal();
      return;
    }

    variantSubmitTrigger = event.target.closest('[data-side-cart-variant-submit]');
    if (variantSubmitTrigger) {
      event.preventDefault();
      addUpsell(variantSubmitTrigger.getAttribute('data-variant-id'), variantSubmitTrigger, closeVariantModal);
      return;
    }

    upsellTrigger = event.target.closest('[data-side-cart-upsell-add]');
    if (upsellTrigger) {
      event.preventDefault();
      addUpsell(upsellTrigger.getAttribute('data-variant-id'), upsellTrigger);
      return;
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!isDrawerForm(form)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    addItem(form, form.querySelector('[type="submit"]'));
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (activeUpsellProduct) {
        closeVariantModal();
        return;
      }

      closeDrawer();
    }
  });

  document.addEventListener('scroll', function (event) {
    if (event.target && event.target.hasAttribute && event.target.hasAttribute('data-side-cart-upsells-viewport')) {
      updateUpsellCarouselState();
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeFreeGiftState();
      updateUpsellCarouselState();
    });
  } else {
    initializeFreeGiftState();
    updateUpsellCarouselState();
  }
})();
